import axios from "axios";
import store from "@/store/index.js";
import {BaseUrl} from "@/utils/config";
import {ElMessage} from "element-plus";
import { message } from '@/utils/common';
import router from "@/router";
import {loadings} from '@/utils/common';


// 创建 Axios 实例并设置全局拦截器
const axiosInstance = axios.create({
    baseURL: BaseUrl,
});

axiosInstance.interceptors.request.use(
    config => {
        // 添加授权标头到每个请求
        config.headers['Authorization'] = store.getters['basic/get_token'] ?? '';
        return config;
    },
    err => {
        // 请求拦截器错误处理
        return Promise.reject(err);
    }
);

axiosInstance.interceptors.response.use(
    response => {
        if (response.data.code === -10001) {
            // 会话过期或未授权，重定向到登录页面
            router.push({ path: '/login' }).then(r => r);
        }
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

const http = ({ url, data, tip = false,files = false,loading = false}) => {

    if (loading){
        loadings.show();
    }

    return new Promise((resolve, reject) => {
        // 根据 files 参数设置 Content-Type
        const headers = {
            "Content-Type": files ? "multipart/form-data" : "application/json",
        };

        axiosInstance.post(url, data, { headers })
            .then(res => {
                if (res.data.code === -10001) {
                    // 会话过期或未授权，重定向到登录页面
                    router.push({ path: '/login' }).then(r => r);
                }

                // 如果需要，显示消息提示
                if (tip) {
                    message[res.data.code === 0 ? 'success' : 'error'](res.data.msg);
                }
                if (loading){
                    loadings.hide();
                }
                resolve(res.data);
            })
            .catch(error => {
                // 记录错误并拒绝 Promise
                console.error("HTTP request failed:", error);

                if (loading){
                    loadings.hide();
                }
                reject(error);
            });
    })
}

// GET请求方法
const httpGet = ({ url, params, tip = false, loading = false }) => {
    if (loading){
        loadings.show();
    }

    return new Promise((resolve, reject) => {
        axiosInstance.get(url, { params })
            .then(res => {
                if (res.data.code === -10001) {
                    // 会话过期或未授权，重定向到登录页面
                    router.push({ path: '/login' }).then(r => r);
                }

                // 如果需要，显示消息提示
                if (tip) {
                    ElMessage({
                        message: res.data.msg,
                        type: res.data.code === 0 ? 'success' : 'error',
                    });
                }
                if (loading){
                    loadings.hide();
                }
                resolve(res.data);
            })
            .catch(error => {
                // 记录错误并拒绝 Promise
                console.error("HTTP GET request failed:", error);

                if (loading){
                    loadings.hide();
                }
                reject(error);
            });
    })
}

export default http;
export { httpGet, axiosInstance };